import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";

import HeaderPortal from "components/portal/header-portal";

export default function JobTitles() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            sortable: true,
        },
    ];

    const fields = ["id", "name"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="job_titles"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Job Titles</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Job Titles"
                    endPoint="job_titles"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="name"
                    sortOrder="aesc"
                    href={(item) => item.id}
                />
            </div>
        </div>
    );
}
